import { render, staticRenderFns } from "./TabelaEquipamentos.vue?vue&type=template&id=7f8655af&"
import script from "./TabelaEquipamentos.vue?vue&type=script&lang=js&"
export * from "./TabelaEquipamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports